import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DialogConfirmation } from '../../../../components/dialog/confirmation';
import { environment } from '../../../../environment';
import { ROUTES } from '../../../../routes/routes';
import { isProd } from '../../../../utils/helpers/environment';
import { useAboutSettings } from '../../hooks/use-about-settings';

export const AboutSettings: React.FC = () => {
  const { t } = useTranslation('profile');
  const { t: tc } = useTranslation('common');
  const navigate = useNavigate();
  const [demoClicks, setDemoClicks] = useState<number>(0);
  const { handleClearAppData, showAppDataClearDialogConfirmation, setShowAppDataClearDialogConfirmation } =
    useAboutSettings();

  const handleDemoClick = () => {
    if (isProd) return;

    const newCount = demoClicks + 1;
    setDemoClicks(newCount);

    if (newCount === 3) navigate(ROUTES.Demo());
    if (newCount > 3) setDemoClicks(0);
  };

  return (
    <>
      <span className="caption">{t('application-data')}</span>
      <div className="grid-list-24">
        <button className="button button--secondary" onClick={() => setShowAppDataClearDialogConfirmation(true)}>
          {t('clear-app-data.button')}
        </button>
      </div>
      <h3 className="m-t-24 m-b-16">{t('application-version')}</h3>
      <p className="p-l-0 p-r-0 m-b-0" onClick={handleDemoClick}>
        {environment.VERSION}
      </p>
      <DialogConfirmation
        show={showAppDataClearDialogConfirmation}
        setShow={setShowAppDataClearDialogConfirmation}
        header={t('clear-app-data.header')}
        content={t('clear-app-data.content')}
        secondaryBtnText={tc('buttons.cancel')}
        primaryBtnText={t('clear-app-data.confirm')}
        secondaryBtnAction={() => setShowAppDataClearDialogConfirmation(false)}
        primaryBtnAction={handleClearAppData}
        direction="column"
      />
    </>
  );
};
